import {
  SGA_SPEND_EVIDENCE_KEY_BY_LEVER,
  SGA_SPEND_EVIDENCE_KEYS,
} from './evidenceKeys';

// Certified SG&A lever snapshots use the evidence key as their manifest state
// key. Alias the object itself so the value cannot be retyped and drift.
export const SGA_SPEND_STATE_KEY_BY_LEVER = SGA_SPEND_EVIDENCE_KEY_BY_LEVER;

export const SGA_SPEND_STATE_KEYS = {
  approvedLeverSnapshots: 'sga_spend_approved_lever_snapshots',
  costPoolMapping: SGA_SPEND_EVIDENCE_KEYS.costPoolMapping,
  certifiedLeverMetrics: SGA_SPEND_EVIDENCE_KEYS.certifiedLeverMetrics,
  financeLineReconciliation: SGA_SPEND_EVIDENCE_KEYS.financeLineReconciliation,
  observedSpendFeed: SGA_SPEND_EVIDENCE_KEYS.observedSpendFeed,
  governedFloor: SGA_SPEND_EVIDENCE_KEYS.governedFloor,
} as const;

export type SgaSpendStateKey =
  (typeof SGA_SPEND_STATE_KEY_BY_LEVER)[keyof typeof SGA_SPEND_STATE_KEY_BY_LEVER];
